import { Badge } from "reactstrap";
import { DATE_FORMAT_VIEW } from "@src/utility/constants";
import LoadingButton from "@components/ui-components/loading-button";
import StatsFormatter from "@components/formatters/stats-formatter";
import { getStatusBadge } from "@src/utility/helpers/utils";
import useDateHandler from "@hooks/use-date-handler";
import { useTranslation } from "react-i18next";

export const decoColumns = () => {
    const { t } = useTranslation();
    const { dateFormatter } = useDateHandler();

    return [
        {
            name    : "Status",
            selector: row => row.status,
            width   : "300px",
            cell    : row => (
                <Badge color={getStatusBadge(row.status).color}>
                    {t(getStatusBadge(row.status).title)}
                </Badge>
            )
        },
        {
            name    : "ID",
            selector: row => row.id,
            width   : "300px",
            cell    : row => (
                row.id
            )
        },
        {
            name    : "Amount",
            selector: row => row.amount,
            width   : "200px",
            cell    : row => (
                <StatsFormatter
                    className=""
                    num={row.amount}
                    prefix="$"
                    id={row._id}/>
            )
        },
    
        {
            name    : "Created On",
            selector: row => row.created_at,
            width   : "350px",
            cell    : row => (
                <span>
                    <i className="mdi mdi-calendar me-1 font-medium-2" />
                    {dateFormatter({
                        date    : row?.created_at,
                        formatAs: DATE_FORMAT_VIEW
                    })}
                </span>
            )
        },
        {
            name : "Created On",
            width: "150px",
            cell : row => (
                <>
                    <LoadingButton
                        className="me-1 text-primary"
                        outline
                        id={`${row._id}-view-button`}
                        text="View Invoice"/>
                </>
            )
        }
    ];
};